import React, { useState, useEffect } from "react";
import api from "../api";
import Select from "react-select";

const TeacherSubjectAssignPage = () => {
    const [teachers, setTeachers] = useState([]);
    const [subjects, setSubjects] = useState([]);
    const [assignedSubjects, setAssignedSubjects] = useState([]);
    const [selectedTeacher, setSelectedTeacher] = useState(null);
    const [selectedSubjects, setSelectedSubjects] = useState([]);
    const [msg, setMsg] = useState(null);
    const [loading, setLoading] = useState(false);
    const [isSidebarOpen, setIsSidebarOpen] = useState(true);

    const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

    const schoolId = localStorage.getItem("school_id");

    const teacherURL = `/teachers/list`;
    const subjectURL = `/subjects/list`;
    const assignURL = `/teacher-subjects/add`;
    const assignedListURL = `/teacher-subjects/list`;

    // fetch teachers
    const fetchTeachers = async () => {
        try {
            const res = await api.get(`${teacherURL}?school_id=${schoolId}`);
            setTeachers(res.data?.data || []);
        } catch (err) {
            console.error("Error fetching teachers:", err);
        }
    };

    // fetch subjects
    const fetchSubjects = async () => {
        try {
            const res = await api.get(`${subjectURL}?school_id=${schoolId}`);
            setSubjects(res.data?.data || []);
        } catch (err) {
            console.error("Error fetching subjects:", err);
        }
    };

    // fetch assigned subjects
    const fetchAssignedSubjects = async (teacherId) => {
        if (!teacherId) return;
        try {
            const res = await api.get(
                `${assignedListURL}?school_id=${schoolId}&teacher_id=${teacherId}`
            );
            setAssignedSubjects(res.data?.data || []);
        } catch (err) {
            console.error("Error fetching assigned subjects:", err);
        }
    };

    useEffect(() => {
        fetchTeachers();
        fetchSubjects();
    }, []);

    useEffect(() => {
        if (selectedTeacher) {
            fetchAssignedSubjects(selectedTeacher.value);
        } else {
            setAssignedSubjects([]);
        }
    }, [selectedTeacher]);

    const handleAssign = async (e) => {
        e.preventDefault();
        if (!selectedTeacher || selectedSubjects.length === 0) {
            setMsg({ type: "error", text: "Select a teacher and at least one subject" });
            return;
        }

        try {
            setLoading(true);
            const payload = {
                teacher_id: selectedTeacher.value,
                subject_ids: selectedSubjects.map((s) => s.value),
            };
            const res = await api.post(assignURL, payload);

            if (res.data?.status) {
                setMsg({ type: "success", text: res.data.message });
                setSelectedSubjects([]);
                fetchAssignedSubjects(selectedTeacher.value);
            } else {
                setMsg({ type: "error", text: res.data.message });
            }
        } catch (err) {
            setMsg({
                type: "error",
                text: err.response?.data?.message || "Network error",
            });
        } finally {
            setLoading(false);
        }
    };

const handleDelete = async (subjectId) => {
    if (!selectedTeacher) {
        setMsg({ type: "error", text: "Select teacher first" });
        return;
    }

    //if (!window.confirm("Are you sure you want to remove this subject?")) return;

    try {
        const res = await api.post("/teacher-subjects/delete", {
            teacher_id: selectedTeacher.value,
            subject_id: subjectId,
        });

        if (res.data.status) {
            setMsg({ type: "success", text: res.data.message });
            fetchAssignedSubjects(selectedTeacher.value);
        } else {
            setMsg({ type: "error", text: res.data.message });
        }
    } catch (err) {
        console.error("Delete error:", err);
        setMsg({
            type: "error",
            text: err.response?.data?.message || "Failed to delete subject.",
        });
    }
};




    return (
        <div style={{ display: "flex", minHeight: "100vh" }}>
            <div style={{ flex: 1, background: "#f4f6f8" }}>
                <main
                    style={{
                        padding: "30px",
                        maxWidth: "900px",
                        margin: "auto",
                        marginTop: "0px",
                    }}
                >
                    <section style={cardStyle}>
                        <h2 style={titleStyle}>📚 Assign Subjects to Teacher</h2>

                        {msg && (
                            <div
                                style={{
                                    marginBottom: 12,
                                    color: msg.type === "error" ? "#cc0000" : "#166534",
                                }}
                            >
                                {msg.text}
                            </div>
                        )}

                        <form onSubmit={handleAssign}>
                            <div style={formGrid}>
                                <FormGroup label="Teacher">
                                    <Select
                                        options={teachers.map((t) => ({
                                            value: t.id,
                                            label: `${t.name} (${t.mobile})`,
                                        }))}
                                        value={selectedTeacher}
                                        onChange={(selected) => setSelectedTeacher(selected)}
                                        placeholder="Select teacher..."
                                        isClearable
                                        isSearchable
                                    />
                                </FormGroup>

                                <FormGroup label="Subjects">
                                    <Select
                                        options={subjects.map((s) => ({
                                            value: s.id,
                                            label: s.subject_name,
                                        }))}
                                        value={selectedSubjects}
                                        onChange={(selected) => setSelectedSubjects(selected || [])}
                                        placeholder="Select subjects..."
                                        isMulti
                                        isClearable
                                        isSearchable
                                    />
                                </FormGroup>
                            </div>

                            <div style={{ textAlign: "right", marginTop: "20px" }}>
                                <button type="submit" style={buttonStyle} disabled={loading}>
                                    {loading ? "Assigning..." : "Assign Subjects"}
                                </button>
                            </div>
                        </form>
                    </section>

                    {selectedTeacher && (
                        <section style={cardStyle}>
                            <h2 style={titleStyle}>📋 Assigned Subjects</h2>
                            {assignedSubjects.length === 0 ? (
                                <p>No subjects assigned.</p>
                            ) : (
                                <table style={tableStyle}>
                                    <thead>
                                        <tr>
                                            <th>Subject ID</th>
                                            <th>Subject Name</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {assignedSubjects.map((subj) => (
                                            <tr key={subj.subject_id}>
                                                <td>{subj.subject_id}</td>
                                                <td>{subj.subject_name}</td>
                                                <td>
                                                    <button
                                                        style={{ ...buttonStyle, background: "red" }}
                                                        onClick={() => handleDelete(subj.subject_id)}
                                                    >
                                                        Delete
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            )}
                        </section>

                    )}
                </main>
            </div>
        </div>
    );
};

// Shared Components
const formGrid = { display: "grid", gridTemplateColumns: "1fr 1fr", gap: "20px" };

const FormGroup = ({ label, children }) => (
    <div>
        <label
            style={{ marginBottom: "6px", display: "block", fontWeight: 500, color: "#444" }}
        >
            {label}
        </label>
        {children}
    </div>
);

const buttonStyle = {
    padding: "8px 18px",
    backgroundColor: "#0077cc",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    fontSize: "14px",
    cursor: "pointer",
};

const cardStyle = {
    background: "#ffffff",
    padding: "25px",
    borderRadius: "12px",
    marginBottom: "30px",
};
const titleStyle = { color: "#0077cc", marginBottom: "25px" };
const tableStyle = { width: "100%", borderCollapse: "collapse" };

export default TeacherSubjectAssignPage;
